// extracted by mini-css-extract-plugin
module.exports = {"block":"_13804","box":"_14301","info":"_11621"};